/*
 * @Author: chenzheng
 * @Date: 2019-01-08 20:53:57
 * @LastEditors: chenzheng
 * @LastEditTime: 2019-03-10 16:08:06
 * @Description:  账户接口
 */

import { get, post } from '@common/http'

// import env from '@common/env'
/**
 * 登录
 * @param param
 * @returns {*}
 */
export const getLoginData = (param, config) => post(`/user/login`, param, config)

/**
 * 根据auth_code 获取授权信息
 * @param param
 * @returns {*}
 */
export const getAuthInfo = param => get(`/auth/info`, param)

/**
 * 授权跳转
 * @param param
 * @returns {*}
 */
export const getAuthJump = param => get(`/auth/jump`, param)

/**
 * 发送短信息验证码,type值：1:登录验证，2：注册验证 3：忘记密码 4:更换手机号
 * @param param
 * @returns {*}
 */
export const getSms = param => get(`/sms`, param)

/**
 * 登录后修改密码
 * @param param
 * @returns {*}
 */
export const getUserChangePWD = param => post(`/user/change-pwd`, param)

/**
 * 选择店铺
 * @param param
 * @returns {*}
 */
export const selectStore = param => post('/user/choose-tenant', param)

/**
 * 忘记密码并修改
 * @param param
 * @returns {*}
 */
export const modifyPassword = (param, config) => post('/user/forget-change-pwd', param, config)

/**
 * 用户注册
 * @param param
 * @returns {*}
 */
export const userRegister = (param, config) => post('/user/register', param, config)

/**
 * 获取当前用户的资源权限
 * @param param
 * @returns {*}
 */
export const userPermission = param => get('/user/permission', param)



// WEBPACK FOOTER //
// ./src/api/account.js